const faqs = [
  {
    q: '亲亲漫画需要付费吗？',
    a: '完全不需要！亲亲漫画平台上所有韩漫、日漫、国漫资源均为免费阅读。我们致力于为漫画爱好者提供海量免费全集在线阅读体验，下拉式阅读，随时随地畅快追漫。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '亲亲漫画支持电脑、平板和手机等全设备访问。网页端自适应布局、移动端完美适配，无论使用哪种设备，都能获得流畅的下拉式漫画阅读体验。',
  },
  {
    q: '漫画更新频率如何？',
    a: '亲亲漫画每日不间断更新热门推荐漫画。韩漫、日漫、国漫均有稳定的更新节奏，热门连载作品通常当天同步更新，确保读者第一时间看到最新话。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '你可以通过首页的热门推荐、人气榜单、话题标签快速发现好看的漫画。也可以按地域筛选韩漫、日漫、国漫，或通过分类标签查找特定类型的漫画作品。',
  },
  {
    q: '可以下载漫画离线阅读吗？',
    a: '目前亲亲漫画以在线阅读为主要方式，所有漫画均支持流畅的下拉式阅读体验。移动端缓存功能正在开发中，敬请期待离线阅读功能的推出。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          常见问答
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group border border-background-200/70 rounded-xl bg-background-50 overflow-hidden" open={i === 0}>
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/60 transition-colors list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-secondary-600 text-sm"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}